<template>
  <div class="xv_view" id="Hospitals_G">
    <div class="xv_top">
      <div>
        <label class="xv_view_title">Hospitals</label>
      </div>
      <div class="xv_actions">
        <button class="sec_btn m_r" @click="import_hospital()">
          Import
          <span class="mdi mdi-cloud-download-outline"></span>
        </button>
        <button class="main_btn" @click="add_hospital()">
          New Hospital
          <span class="mdi mdi-plus-thick"></span>
        </button>
      </div>
    </div>
    <div class="xv_table">
      <div class="xv_table_title">
        <div>
          <span>Hospitals (7)</span>
        </div>
        <div class="table_search">
          <span class="mdi mdi-magnify"></span>
          <input type="text" placeholder="Search by Hospital" />
        </div>
      </div>
      <table class="office_table">
        <thead>
          <tr>
            <th style="width:20%">Name</th>
            <th style="width:16%;text-align:center">State</th>
            <th style="width:16%;text-align:center">District</th>
            <th style="width:16%;text-align:center">City</th>
            <th style="width:16%;text-align:center">Doctors</th>
            <th style="width:16%;text-align:center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span id="American" @click="view_hospital">American Hospital</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Lebanon</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Fortis" @click="view_hospital">Fortis</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Retro</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="carilione" @click="view_hospital">Carilione</span>
            </td>
            <td>
              <span>Switzerland</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Venis</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="kaiser" @click="view_hospital">Kaiser</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Yishun</span>
            </td>
            <td>
              <span>Yoohan</span>
            </td>
            <td>
              <span>18</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="mediclinic" @click="view_hospital">Mediclinic</span>
            </td>
            <td>
              <span>United States</span>
            </td>
            <td>
              <span>Tampines</span>
            </td>
            <td>
              <span>Champeg</span>
            </td>
            <td>
              <span>22</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="global" @click="view_hospital">Global Hospitals</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Hougang</span>
            </td>
            <td>
              <span>Siezure</span>
            </td>
            <td>
              <span>30</span>
            </td>
            <td class="status_1">
              <span>Ok</span>
            </td>
          </tr>
          <tr>
            <td>
              <span id="Tencent" @click="view_hospital">Pacifica Salud</span>
            </td>
            <td>
              <span>Greater China</span>
            </td>
            <td>
              <span>Pasir Ris</span>
            </td>
            <td>
              <span>Reius</span>
            </td>
            <td>
              <span>32</span>
            </td>
            <td class="status_2">
              <span>Closed</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Add office modal -->
    <modal name="add_hospital" transition="pop-out" :width="600" height="auto">
      <addHospital></addHospital>
    </modal>
    <!-- Import office modal -->
    <modal name="import_hospital" transition="pop-out" :width="600" height="auto">
      <importHospital></importHospital>
    </modal>
  </div>
</template>

<script>
import addHospital from "./add_hospital/add_hospital.vue";
import importHospital from "./import_hospital/import_hospital.vue";

export default {
  name: "Hospitals_G",
  components: {
    addHospital,
    importHospital
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    add_hospital: function() {
      this.$modal.show("add_hospital");
    },
    import_hospital: function() {
      this.$modal.show("import_hospital");
    },
    view_hospital: function(e) {
      var id = e.currentTarget.id;
      this.$router.push("/xv-admin-g/hospitals:" + id);
    }
  }
};
</script>
